import { ListBox } from "primereact/listbox";
import { Skeleton } from "primereact/skeleton";
import { Message } from "primereact/message";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/redux";
import FilterCard from "./FilterCard";
import { academicYearsApi } from "../../services/nomenclatures/academicYearsApi";
import { AcademicYearResponse } from "../../models/dtos";
import FilterBox from "./FilterBox";
import { RootState } from "../../store";

type AcademicYearFilterProps = {
  getSelectedAcademicYears: (state: RootState) => AcademicYearResponse[];
  setSelectedAcademicYears: any;
};

const AcademicYearFilter = ({ getSelectedAcademicYears, setSelectedAcademicYears }: AcademicYearFilterProps) => {
  const selectedAcademicYears = useSelector(getSelectedAcademicYears);
  const dispatch = useAppDispatch();

  const { data: academicYears, error, isLoading } = academicYearsApi.useGetAcademicYearsQuery();

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Message severity="error" text={JSON.stringify(error)} />;

  return (
    <FilterCard title="По година на прием:">
      <FilterBox<AcademicYearResponse>
        filter
        value={selectedAcademicYears}
        onChange={(e) => dispatch(setSelectedAcademicYears(e.value))}
        options={academicYears?.data ?? []}
        dataKey="academicYearId"
        optionLabel="name"
        listClassName="max-h-12rem"
      />
    </FilterCard>
  );
};

export default AcademicYearFilter;
